import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ensureUser } from "@/lib/user";
import Header from "@/components/Header";
import Feed from "@/pages/Feed";
import MoodTracker from "@/pages/MoodTracker";
import Profile from "@/pages/Profile";
import PostDetail from "@/pages/PostDetail";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ensureUser()
      .then(setUser)
      .finally(() => setLoading(false));
  }, []);

  if (loading || !user) {
    return (
      <div className="App grain min-h-screen flex items-center justify-center">
        <div className="font-display text-3xl ember-text flame-pulse" data-testid="loading-state">
          twatter
        </div>
      </div>
    );
  }

  return (
    <div className="App grain">
      <BrowserRouter>
        <Header user={user} setUser={setUser} />
        <main className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/" element={<Feed user={user} />} />
            <Route path="/mood" element={<MoodTracker user={user} />} />
            <Route path="/profile" element={<Profile user={user} setUser={setUser} />} />
            <Route path="/vent/:id" element={<PostDetail user={user} />} />
          </Routes>
        </main>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#15131A",
              border: "1px solid #2D2838",
              color: "#F3F1F6",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
